import "../pages.scss"
import { RubrosState } from '../../context/rubros/RubrosState';
import Datatable from "./rubrosTable/Datatable"

const RubrosPage = () => {
  return (
    <>
      <RubrosState>
        <Datatable />
      </RubrosState>

    </>
  )
}

export default RubrosPage